import script from "./NoticeView.vue?vue&type=script&lang=ts&setup=true"
export * from "./NoticeView.vue?vue&type=script&lang=ts&setup=true"

import "./NoticeView.vue?vue&type=style&index=0&id=019560e6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-019560e6"]])

export default __exports__